module.exports = __webpack_public_path__ + "static/fashion-movies-banner-c6de71e5b3b398a26d9a5990b6a56f77.jpg";